<app-component-factory
  [data]="data"
  [componentClass]="forceType(componentClass)"
  (isVisibleChanged)="isVisibleChanged.emit($event)"
></app-component-factory>
